/**
 * Mapping des slugs SEO courts → articles magazine canoniques.
 *
 * Objectif : permettre à Google d'indexer des URLs courtes et
 * keyword-rich (ex. /casque-moto-ece-22-06) plutôt que des URLs
 * verbeuses (/magazine/bien-choisir-casque-moto). Le contenu est
 * identique, seul le canonical diffère (via `pathOverride`).
 *
 * Convention :
 *  - `path`     : URL publique courte (kebab-case, mots-clés cibles)
 *  - `slug`     : slug d'article dans MAGAZINE_ARTICLES
 *  - `topic`    : clé optionnelle pour <RelatedLinks>
 *
 * IMPORTANT :
 * Cette liste est **aussi** la source de vérité du sitemap.xml
 * pour les URLs courtes (à régénérer après ajout).
 */

export const SEO_SHORT_ROUTES = [
  {
    path: '/casque-moto-ece-22-06',
    slug: 'bien-choisir-casque-moto',
    topic: 'casque',
    label: 'Casque moto · norme ECE 22-06',
  },
  {
    path: '/permis-a1-a2',
    slug: 'passer-le-permis-a1-a2',
    topic: 'permis-a1-a2',
    label: 'Permis A1 / A2 — déroulement',
  },
  {
    path: '/equipement-moto-obligatoire',
    slug: 'equipement-complet-motard-2026',
    topic: 'epi',
    label: 'Équipement obligatoire moto',
  },
  {
    path: '/gants-moto-homologues',
    slug: 'gants-moto-homologues',
    topic: 'gants',
    label: 'Gants moto homologués CE',
  },
  {
    path: '/trajectoires-moto-securite',
    slug: 'trajectoire-securite-virage',
    topic: 'trajectoires',
    label: 'Trajectoires de sécurité',
  },
  {
    path: '/distances-securite-moto',
    slug: 'distances-securite-moto',
    topic: 'distances',
    label: 'Distances de sécurité',
  },
  {
    path: '/alcool-stupefiants-moto',
    slug: 'alcool-stupefiants-moto',
    topic: 'alcool',
    label: 'Alcool & stupéfiants à moto',
  },
];

/**
 * Lookup helper.
 */
export function findShortRouteByPath(path) {
  return SEO_SHORT_ROUTES.find((r) => r.path === path);
}

export function findShortRouteBySlug(slug) {
  return SEO_SHORT_ROUTES.find((r) => r.slug === slug);
}
